import React, { useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import Note from "./Note";
import CreateArea from "./CreateArea";

function App() {
  const [notes, setNotes] = useState([]);

  function addNote(note) {
    setNotes((prevNotes) => {
      return [...prevNotes, note];
    });
  }

  function deleteNote(id) {
    setNotes((prevNotes) => {
      return prevNotes.filter((note, index) => {
        return index !== id;
      });
    });
  }

  return (
    <div>
      <Header />
      <CreateArea onClick={addNote} />
      <div>
        {notes.map((note, index) => {
          return (
            <Note
              onDelete={deleteNote}
              key={index}
              id={index}
              title={note.title}
              content={note.content}
            />
          );
        })}
      </div>
      <Footer />
    </div>
  );
}

export default App;
